import React, { FC, ReactNode } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Typography } from "@mui/material";
import { tss } from "tss-react/mui";

const useStyles = tss.create(() => ({
  label: {
    textAlign: "left",
  },
  value: {
    textAlign: "right",
  },
  valueBold: {
    textAlign: "right",
    fontWeight: "bold",
  },
}));

interface PriceRowProps {
  label: string;
  value: string | ReactNode;
  bold?: boolean;
  fontSize?: number | string;
  labelFontSize?: number | string;
  labelVariant?: "body2" | "body1" | "subtitle2" | "h6";
  valueVariant?: "body2" | "body1" | "h1" | "h2" | "h3" | "h6";
  labelMarginRight?: number;
}

const PriceRow: FC<PriceRowProps> = ({
  label,
  value,
  bold = false,
  fontSize,
  labelFontSize,
  labelVariant = "body1",
  valueVariant = "body1",
  labelMarginRight = 0,
}) => {
  const { classes } = useStyles();

  return (
    <>
      <Grid xs={8}>
        <Typography
          className={classes.label}
          variant={labelVariant}
          sx={{
            fontSize: labelFontSize,
            mr: labelMarginRight,
          }}>
          {label}:
        </Typography>
      </Grid>
      <Grid xs={4}>
        <Typography
          className={bold ? classes.valueBold : classes.value}
          variant={valueVariant}
          sx={{
            fontSize,
          }}>
          {value}
        </Typography>
      </Grid>
    </>
  );
};

export default PriceRow;
